import React, { useEffect, useState } from 'react';
import { useAuth } from '../auth/AuthContext';
import Loading, { useLoaderConfig } from './Loading';

export default function StartupSplash({ children }) {
  const { initialized } = useAuth();
  const config = useLoaderConfig();
  const [mounted, setMounted] = useState(true);
  const [hiding, setHiding] = useState(false);
  useEffect(() => {
    if (!initialized || !config.enabled) return;
    const min = window.setTimeout(() => setHiding(true), config.startupHideDelayMs);
    const remove = window.setTimeout(() => setMounted(false), config.startupRemoveDelayMs);
    return () => { window.clearTimeout(min); window.clearTimeout(remove); };
  }, [initialized, config]);
  return <>
    {children}
    {mounted && config.enabled && <div className={`startup-splash${hiding ? ' startup-splash--hide' : ''}`} aria-hidden="true">
      <Loading label="" />
    </div>}
  </>;
}
